import axios from "axios";

export function getPageUrl() {
  const url = new URL(window.location.href);
  const pageUrl = url.searchParams.get("page") || "";

  if (process.env.NODE_ENV === "development" && !pageUrl) {
    url.searchParams.append("page", "http://127.0.0.1:8190/static/index.html");
    window.location.href = url.toString();
  }

  return pageUrl;
}

export function setToken() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");
  if (token) {
    axios.defaults.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
}

export function getBaseUrl() {
  const url = getPageUrl();
  let getBaseUrl = url;
  const lastIndex = url.lastIndexOf("/");

  if (lastIndex < url.length && lastIndex > -1) {
    getBaseUrl = url.slice(0, lastIndex);
  }
  return getBaseUrl;
}
